import createPermission from 'permissions/createPermission'

import list from 'permissions/remoteInspections/list'

export default createPermission(list)